import React from 'react'
import classnames from 'classnames'

import styles from './styles.css'

const Answer = () => (
  <div>
    <p className={classnames(styles.text, styles.section)}>
      In their best selling book Designing Your Life, Bill Burnett and Dave Evans* recommend tracking your engagement level in the various daily activities that you do. This is intended to help you formulate a better understanding of what aspects of your work you are passionate about and that are likely to bring you self-fulfillment and success.
    </p>
    <p className={classnames(styles.text, styles.section)}>
      In addition to your engagement level (suggested scale is 1 to 5, where 5 represents the highest level of engagement), you are also encouraged to track any insights that you realize along the way.
    </p>

    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>This habit of tracking your engagement</span>
    </p>
    <p className={classnames(styles.text, styles.section)}>
      This habit of tracking your engagement, both quantifying it in the form of ranking the level of engagement and adding the qualitative dimension in the form of an insight, not only help you design your work life and evolve your role and your projects accordingly in the future, but also help you become increasingly self-aware and better manage your work in the present.
    </p>

    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>Capturing engagement in this form</span>
    </p>
    <p className={classnames(styles.text, styles.section)}>
      Please note that engagement relates to the current task. Therefore you must have a task in progress to be able to track engagement.
    </p>
    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>Rank field:</span> This is where you rank your engagement (see ranking details above).
    </p>
    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>Reflection field:</span> This is where you would pause and reflect, and then jot down your reflections include any insights you have as a result of this engagement level in the current task.
    </p>

    <p className={classnames(styles.text, styles.section)}>
      <span className={styles.bold}>You can also enable tracking engagement in the Settings Page</span>
    </p>
    <p className={classnames(styles.text, styles.section)}>
      Please note that you can also enable the tracking engagement setting in the Settings Page  so that the engagement form pops up automatically upon the completion of a task, prompting you to be mindful about your engagement and filling in the level of engagement and any relevant reflections.
    </p>
    <p className={classnames(styles.text, styles.section)}>
      You can later review your engagement history in the Log Page and reflect further on what it all means.
    </p>
    <p className={classnames(styles.text, styles.section)}>
      Don’t let life go by “undesigned” and valuable data and insights “unrecognized!” Track your engagement:)
    </p>
    <p className={classnames(styles.text, styles.section, styles.italic)}>
      *Dave Evans, co-author of Designing Your Life spoke at our lunch & learn webinar about the topic of designing your life mindfully and you can <a className={styles.link} target="_blank" href="https://www.youtube.com/watch?v=LJYS_RgMyGk&t=1645s">view the recording here</a> for additional insights related to this topic.
    </p>
  </div>
)

export default Answer



// WEBPACK FOOTER //
// ./src/components/categoryTabs/engagementForm/answer/index.js